
import { isEmpty } from "./functions";

class ValidationRule 
{
    public required(value:any): boolean
    {
        return !isEmpty(value);
    }
}

export const RuleMessage: any = {
    required: "The :attribute field is required",
}

export default new ValidationRule;